module.exports = __webpack_public_path__ + "img/Banner.46533249.png";